import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BmrCalc } from "../components/BmrCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.bmr_tool_name()}
        toolPath="/bmr-calculator"
      />
      <SciHeader title={m.bmr_h1()} intro={m.bmr_intro()} />
      <BmrCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.bmr_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.bmr_ex1(), m.bmr_ex2(), m.bmr_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.bmr_faq_q1(), a: m.bmr_faq_a1() },
          { q: m.bmr_faq_q2(), a: m.bmr_faq_a2() },
          { q: m.bmr_faq_q3(), a: m.bmr_faq_a3() },
          { q: m.bmr_faq_q4(), a: m.bmr_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
